import { useSyncExternalStore } from 'react';

import { getIsRefreshing, subscribeRefreshState } from './index';

export const useIsTokenRefreshing = (): boolean => {
  return useSyncExternalStore(subscribeRefreshState, getIsRefreshing);
};
